import { TrafficLightZone } from '../../../../api-service/clients';

export const CANCEL_CONFIRM_MESSAGE = 'Vil du fortryde dine ændringer?';

export const zoneConfig: Record<TrafficLightZone, { label: string; accent: string; tint: string }> = {
  [TrafficLightZone.Green]: { label: 'Grøn', accent: '#2e7d32', tint: '#e8f5e9' },
  [TrafficLightZone.Yellow]: { label: 'Gul', accent: '#fbc02d', tint: '#fffde7' },
  [TrafficLightZone.Red]: { label: 'Rød', accent: '#c62828', tint: '#fdecea' },
};

export interface CommonZoneFields {
  citizenIndicators: string;
  whatHelps: string;
  staffShouldDo: string;
  staffShouldAvoid: string;
}

export interface GreenZoneDraft extends CommonZoneFields {
  zone: TrafficLightZone.Green;
}

export interface YellowZoneDraft extends CommonZoneFields {
  zone: TrafficLightZone.Yellow;
  typicalTriggers: string;
}

export interface RedZoneDraft extends CommonZoneFields {
  zone: TrafficLightZone.Red;
  typicalTriggers: string;
  safetyMeasures: string;
  whoToContact: string;
  debrief: string;
}

export type ZoneDraft = GreenZoneDraft | YellowZoneDraft | RedZoneDraft;
